import React, {useEffect, useState, useContext} from "react";
import styles from "./mainContentsWorkspace/MainContentsWorkspace.module.scss";
import WorkspaceItems from "./mainContentsWorkspace/WorkspaceItems";
import Card from "../../Dashboard/Pages/Home/PurchaseToPay/Card";
import CreateAnalysis from "./mainContentsWorkspace/CreateAnalysis";
import Topbar from "../Topbar";
import appContext from "../../../context/appContext";
import SkeletonLoading from "../../Componnets/SkeletonLoading/SkeletonLoading";
import HeaderErrorBar from "../../Componnets/EsmManagement/headerErrorBar/HeaderErrorBar";

const MainContentsWorkspace = ({
                                 handleShowCreateWorkspaceModal,
                                 handleEditWorkspace,
                                 handleCallGetAnalysisApi,
                                 callAnalysisApi,
                                 handleRetrySaveData,
                                  onFetchMoreItems,
                               }) => {

  const [showCreateAnalysisModal, setShowCreateAnalysisModal] = useState(false);
  const [responseStatus, setResponseStatus] = useState(null);
  const [keyboard, setKeyboard] = useState('');
  const [analysisEditData, setAnalysisEditData] = useState({});
  const [typeOfCreateModal, setTypeOfCreateModal] = useState("addNew");
  const [retryAnalysisSaveData, setRetryAnalysisSaveData] = useState(false);


  const context = useContext(appContext);
  const data = context.handleWorkspace();

  const handleRetrySaveAnalysisData = (status) => {
    setRetryAnalysisSaveData(status);
  }

  const handleShowCreateAnalysisModal = () => {
    setShowCreateAnalysisModal(!showCreateAnalysisModal);
    if (showCreateAnalysisModal) {
      setTypeOfCreateModal('addNew');
    }
  }

  const handleEditAnalysis = (id) => {
    setShowCreateAnalysisModal(true);
    setTypeOfCreateModal('edit');
    const data = context.handleAnalysis().find(item => item.id === id);
    setAnalysisEditData(data);
  }

  const handleAddAnalysisToWorkspaceItem = (analysesItem) => {
    const newData = data.map(item => {
      if (item.id === context.handleSelectedWorkspaceInfo().id) {
        return {...item, analyses: [analysesItem, ...item.analyses]}
      }
      return item;
    });
    context.handleWorkspace(newData);
  }

  const handleAddItemToAnalysisData = (data) => {
    handleAddAnalysisToWorkspaceItem(data);
  }

  const selectedWorkspaceInfo = context.handleSelectedWorkspaceInfo();

  useEffect(() => {
    if (selectedWorkspaceInfo.id) {
      handleSelectWorkspaceItem(selectedWorkspaceInfo.id);
    }
  }, [selectedWorkspaceInfo.id])

  useEffect(() => {
    if (data.length > 0 && data[0].id) {
      if (!selectedWorkspaceInfo.id) {
        handleGetData(data[0].id);
      } else {
        handleGetData((data.find(item => item.id === selectedWorkspaceInfo.id))?.id);
      }
    }
  }, []);

  const handleGetData = (id) => {
    setResponseStatus('fetching');

    if (id) {
      localStorage.setItem('workspaceId', id);
      const selectedWorkspace = data.find(item => item.id === id);
      context.handleAnalysis(selectedWorkspace.analyses)
      context.handleSelectedWorkspaceInfo({id: id, name: selectedWorkspace.name});
    } else {
      context.handleAnalysis(data[0])
      context.handleSelectedWorkspaceInfo({id: data[0].id, name: data[0].name});
    }

    setResponseStatus('success');
  }

  useEffect(() => {
    if (selectedWorkspaceInfo.id && callAnalysisApi) {
      handleGetData(selectedWorkspaceInfo.id);
      handleCallGetAnalysisApi(false);
    }
  }, [callAnalysisApi]);

  const handleSelectWorkspaceItem = (id) => {
    if (selectedWorkspaceInfo.id !== id) {
      handleGetData(id);
    }
  }

  useEffect(() => {
    if (data.length > 0 && !selectedWorkspaceInfo.id) {
      context.handleSelectedWorkspaceInfo({id: data[0].id, name: data[0].name})
    }
  }, []);

  const role = localStorage.getItem("role")

  useEffect(() => {
    return function cleanup() {
      const visitedWorkspaces = JSON.parse(localStorage.getItem("visitedWorkspaces")) || [];
      const workspaceId = localStorage.getItem("workspaceId") || null;
      if (workspaceId && visitedWorkspaces.length) {
        try {
          const find = visitedWorkspaces.find(item => item.workspaceId === workspaceId);
          const filter = visitedWorkspaces.filter(item => item.workspaceId !== workspaceId);
          find.visited = true;
          localStorage.setItem("visitedWorkspaces", JSON.stringify([find, ...filter]));
        } catch (e) {

        }
      }
    }
  }, []);

  return (
    <div className={styles.MainContentsWorkspace}>
      <Topbar
        connectedDataPoolName={(data && selectedWorkspaceInfo.id) && data.find(item => item.id === selectedWorkspaceInfo.id)}
        connected={true}
        canAddNewAnalysis={true}
        handleShowCreateAnalysisModal={handleShowCreateAnalysisModal}
      />
      <div className={styles.backgroundBottom}>
        {/*<svg width="482" height="369" viewBox="0 0 482 369" fill="none" xmlns="http://www.w3.org/2000/svg">*/}
        {/*    <rect opacity="0.6" x="14.1421" y="311.127" width="420" height="420" rx="73" transform="rotate(-45 14.1421 311.127)" stroke="#F0F2FF" stroke-width="20"/>*/}
        {/*</svg>*/}
      </div>
      <div className={`${styles.sidebar} ${styles.h100}`}>
        <WorkspaceItems
          selectedWorkspaceId={selectedWorkspaceInfo && data.length > 0 ? selectedWorkspaceInfo.id || data[0].id : null}
          handleSelectWorkspaceItem={(id) => handleSelectWorkspaceItem(id)}
          handleShowCreateWorkspaceModal={handleShowCreateWorkspaceModal}
          handleEditWorkspace={handleEditWorkspace}
          handleRetrySaveData={handleRetrySaveData}
          onFetchMoreItems={onFetchMoreItems}
        />
      </div>
      <div className={styles.itemsContent}>
        <div className={`d-flex ${styles.searchBar}`}>
          <div>
            <p className={styles.title}>Workspace</p>
            <p className={styles.name}>{selectedWorkspaceInfo.name}</p>
          </div>
          <input onChange={e => setKeyboard(e.target.value.toLocaleLowerCase())} type={'text'} placeholder={'Search'}/>
        </div>
        <div className={'mt-3 mr-3'}>
          <HeaderErrorBar showError={context.handleLostWorkspaceDataConnector()}>
            <div>
              Workspace connection to data connector has been lost. Please check the data connector in <strong>Data
              Pool</strong> or you can create a new one.
            </div>
          </HeaderErrorBar>
        </div>
        {
          responseStatus === 'fetching' && <div className={'mt-3'}><SkeletonLoading/></div>
        }
        {
          context.handleWorkspace().length > 0 ?
            context.handleWorkspace()[0].id ? (
              context.handleAnalysis().length > 0 && selectedWorkspaceInfo.id ?
                responseStatus && responseStatus === 'success' && <main className="purchase-to-pay d-flex flex-wrap">
                  {context.handleAnalysis().map(item => {
                    return (item.name.toLocaleLowerCase().includes(keyboard) || keyboard === '') &&
                      <Card
                        data={item}
                        handleEditAnalysis={handleEditAnalysis}
                        handleRetrySaveAnalysisData={handleRetrySaveAnalysisData}
                        allowShowHint={context.handleAnalysis().length && context.handleAnalysis()[0].id === item.id}
                        key={item.id}
                      />
                  })
                  }
                </main>
                :
                selectedWorkspaceInfo.id && responseStatus !== 'fetching' && <>
                  {
                    (role === "admin" || role === "analyzer") &&
                      <div className={styles.emptyData}>
                        <div className={styles.header}>
                          <div>Now You Can Use Your Brilliant Data Connector</div>
                          <div className={'mt-1'}>Let's Start By Creating a New Analysis</div>
                        </div>
                      </div>
                  }
                  {
                    (role === "admin" || role === "analyzer") ?
                      <div onClick={handleShowCreateAnalysisModal} className={styles.addNewBox}>
                        <div className={`${styles.h100} d-flex align-items-center justify-content-center`}>
                          <div>
                            <div className={'text-center d-flex justify-content-center'}>
                              <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                   xmlns="http://www.w3.org/2000/svg">
                                <path d="M9.99997 6.93945V13.0447" stroke="#8A0FFF" stroke-width="1.5"
                                      stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M13.0556 9.99209H6.94446" stroke="#8A0FFF" stroke-width="1.5"
                                      stroke-linecap="round" stroke-linejoin="round"/>
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                      d="M13.9047 1.66669H6.0952C3.37298 1.66669 1.66663 3.59342 1.66663 6.32098V13.6791C1.66663 16.4066 3.36504 18.3334 6.0952 18.3334H13.9047C16.6349 18.3334 18.3333 16.4066 18.3333 13.6791V6.32098C18.3333 3.59342 16.6349 1.66669 13.9047 1.66669Z"
                                      stroke="#8A0FFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                            </div>
                            <div className={`${styles.addNewText} text-center mt-1`}>
                              Add New Analysis
                            </div>
                          </div>
                        </div>
                      </div>
                      :
                      <div className={[styles.emptyErrorForViewer, "d-flex align-items-center"].join(" ")}>
                        <div className={"mr-4"}>
                          <svg width="75" height="90" viewBox="0 0 75 90" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M74 56.3933C74 74.8145 57.775 89 37.5 89C17.225 89 1 74.8145 1 56.3933C1 37.8379 17.3657 20 37.5 20C57.6343 20 74 37.8379 74 56.3933Z" fill="white" stroke="#C2C7ED" stroke-width="2"/>
                            <path d="M32 11.4267C32 15.0599 28.7645 18 24.5 18C20.2355 18 17 15.0599 17 11.4267C17 7.65964 20.3765 4 24.5 4C28.6235 4 32 7.65964 32 11.4267Z" stroke="#C2C7ED" stroke-width="2"/>
                            <path d="M29 5.49988L25 7.99988L26 11.4999L22.5 14.4999V17.9999" stroke="#C2C7ED" stroke-width="2"/>
                            <g filter="url(#filter0_d_3208_2446)">
                              <path d="M37.99 65.37C33.08 65.36 28.17 66.35 23.26 66.34C22.82 66.34 22.37 66.34 21.93 66.32C20.79 66.27 19.66 66.11 18.67 65.57C17.44 64.9 16.56 63.71 16.01 62.42C15.46 61.13 15.2 59.74 14.96 58.36C14.68 56.74 14.41 55.1 14.51 53.45C14.61 51.8 15.13 50.14 16.24 48.92C17.74 47.29 20.03 46.7 22.2 46.35C27.42 45.5 32.64 44.75 37.89 44.5H37.61C42.86 44.74 48.08 45.5 53.3 46.35C55.47 46.7 57.76 47.29 59.24 48.92C60.35 50.14 60.86 51.8 60.97 53.45C61.08 55.09 60.8 56.74 60.52 58.36C60.28 59.74 60.03 61.13 59.47 62.42C58.92 63.71 58.04 64.9 56.81 65.57C55.82 66.11 54.69 66.27 53.55 66.32C53.11 66.34 52.66 66.34 52.22 66.34C47.31 66.35 42.4 65.36 37.49 65.37" fill="#E8EBFF" fill-opacity="0.2" shape-rendering="crispEdges"/>
                              <path d="M37.99 65.37C33.08 65.36 28.17 66.35 23.26 66.34C22.82 66.34 22.37 66.34 21.93 66.32C20.79 66.27 19.66 66.11 18.67 65.57C17.44 64.9 16.56 63.71 16.01 62.42C15.46 61.13 15.2 59.74 14.96 58.36C14.68 56.74 14.41 55.1 14.51 53.45C14.61 51.8 15.13 50.14 16.24 48.92C17.74 47.29 20.03 46.7 22.2 46.35C27.42 45.5 32.64 44.75 37.89 44.5H37.61C42.86 44.74 48.08 45.5 53.3 46.35C55.47 46.7 57.76 47.29 59.24 48.92C60.35 50.14 60.86 51.8 60.97 53.45C61.08 55.09 60.8 56.74 60.52 58.36C60.28 59.74 60.03 61.13 59.47 62.42C58.92 63.71 58.04 64.9 56.81 65.57C55.82 66.11 54.69 66.27 53.55 66.32C53.11 66.34 52.66 66.34 52.22 66.34C47.31 66.35 42.4 65.36 37.49 65.37" stroke="#C2C7ED" stroke-width="2" shape-rendering="crispEdges"/>
                            </g>
                            <path d="M47 54.5C45 55.5 43.5 55.5 42 54.5001" stroke="#C2C7ED" stroke-width="2" stroke-linecap="round"/>
                            <path d="M33 54.5C31 55.5 29 55.5 28 54.5001" stroke="#C2C7ED" stroke-width="2" stroke-linecap="round"/>
                            <path d="M37 20.0001C37.4466 18.4817 38.3658 8.73165 37 6.00005C33.5 -1.00007 28 2.50012 26 4.00013" stroke="#C2C7ED" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <defs>
                              <filter id="filter0_d_3208_2446" x="5.48889" y="35.5" width="64.5055" height="39.8401" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                                <feOffset/>
                                <feGaussianBlur stdDeviation="4"/>
                                <feComposite in2="hardAlpha" operator="out"/>
                                <feColorMatrix type="matrix" values="0 0 0 0 0.909804 0 0 0 0 0.921569 0 0 0 0 1 0 0 0 1 0"/>
                                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3208_2446"/>
                                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3208_2446" result="shape"/>
                              </filter>
                            </defs>
                          </svg>
                        </div>
                        <div>
                          <p>
                            It seems no analysis has been created for you.
                          </p>
                          <p>
                            To make one, Please contact your system’s admin.
                          </p>
                        </div>
                      </div>
                  }
                </>
            ) : (
              context.handleSaveWorkspaceStatus() === "error" ?
                (
                  <div className={styles.emptyData}>
                    <div className={styles.header}>
                      <div>You should have a saved workspace to create analysis.</div>
                      <div className={'mt-1'}>Workspace not found.</div>
                    </div>
                  </div>
                ) : (
                  <div className={styles.emptyData}>
                    <div className={styles.header}>
                      <div>Wait until workspace creation is completed</div>
                      <div className={'mt-1'}>Pending...</div>
                    </div>
                  </div>
                )
            )
            : null
        }
        <CreateAnalysis
          handleShowCreateAnalysisModal={handleShowCreateAnalysisModal}
          showModal={showCreateAnalysisModal}
          selectedWorkspaceId={selectedWorkspaceInfo.id}
          handleAddItemToAnalysisData={(data) => handleAddItemToAnalysisData(data)}
          type={typeOfCreateModal}
          editData={analysisEditData}
          handleRetrySaveAnalysisData={(status) => handleRetrySaveAnalysisData(status)}
          retrySaveAnalysis={retryAnalysisSaveData}
        />
      </div>
    </div>
  )
}

export default MainContentsWorkspace;